import { Component } from 'react'
import { SelectField, TextField, type Option } from '@retailer-platform/shared-components/src/tds'
import { STRING_TO_BOOLEAN_MAP } from '../../../../../common/constants.tsx'
import isNaN from 'lodash/isNaN'
import isNumber from 'lodash/isNumber'

type CellType = 'dropdown' | 'currency'

interface Props {
  type: CellType
  attribute: string
  // eslint-disable-next-line
  options?: Option[]
  item: {
    [index: string]: string
  }
  onChange: (attribute: string, value: string) => void
}

interface State {
  value: string
  isBusy: boolean
  isError: boolean
}

class ProductLocationsCell extends Component<Props, State> {
  readonly state: State = {
    value: this.props.item[this.props.attribute],
    isBusy: false,
    isError: false,
  }

  onChange = (value: string) => {
    if (this.props.type === 'currency') {
      if (isNaN(+value)) return
      if (!isNumber(+value)) return
    }

    this.setState(
      {
        isError: false,
        value,
      },
      () => this.props.onChange(this.props.attribute, value)
    )
  }

  render() {
    const { type, options } = this.props

    switch (type) {
      case 'dropdown':
        return (
          <SelectField
            width={130}
            value={this.state.value?.toString() || null}
            isLoading={this.state.isBusy}
            disabled={this.state.isError}
            onChange={value => this.onChange(STRING_TO_BOOLEAN_MAP[value])}
            options={options}
          />
        )
      case 'currency':
        return (
          <TextField
            disabled={this.state.isError || this.state.isBusy}
            value={this.state.value}
            onChange={e => this.onChange(e.target.value)}
          />
        )
      default:
        return null
    }
  }
}

export default ProductLocationsCell
